import { Pipe } from "@angular/core"

@Pipe({name: 'replace', standalone: true})
export class ReplacePipe {
    transform(value: string, search: string, replace: string): string {
        return value.replace(search, replace);
    }
}